import React, {useState, useEffect, useContext} from 'react';
import {
    Button,
    Container,
    Grid,    
      TextField,
} from '@mui/material';
import IconButton from "@mui/material/IconButton";
import ClearIcon from '@mui/icons-material/Clear';
import { useHistory } from "react-router-dom";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { OneWamboPerformanceStatus, OneCpPerformanceStatus } from '../gas/shared/service';
import {CurrentUserContext} from "../../components/CurrentUserContext";

const Home = () => {
   // const [access, setAccess] = useState(false);
    const [dashboardAccess, setDashboardAccess] = useState(false);
    const [epoData, setEpoData] = useState([]);
    const [reqData, setReqData] = useState([]);
    const [epoSentData, setEpoSentData] = useState([]);
    const [reqSentData, setReqSentData] = useState([]);
    const [createInvoiceData, setCreateInvoiceData] = useState([]);
    const [deferInvoiceData, setDeferInvoiceData] = useState([]);
    const [paidInvoiceData, setPaidInvoiceData] = useState([]);
    const [projectCodeData, setProjectCodeData] = useState([]); 
  //  const [searchTerm, setSearchTerm] = useState('');
    const [asnData, setAsnData] = useState([]);
    const history = useHistory();    
    const user = useContext(CurrentUserContext)

     useEffect(() =>{  
          const currentUser = user.currentUser;     
          const roleList = currentUser.authorities.map(a=>a.authority); 
         for(let roleSet of roleList){
          // if(roleSet.includes('ROLE_SI_USER')){
          //   setAccess(true);
          // }
          if(roleSet.includes('ROLE_STATUS_USER')){
            setDashboardAccess(true);
            OneWamboPerformanceStatus.getAll().then((response)=> {              
              setEpoData(response.data.daysSinceLastEpo);
              setReqData(response.data.daysSinceLastReq);  
              setAsnData(response.data.daysSinceLastAsn);
              setEpoSentData(response.data.daysSinceLastEpoSent);
              setReqSentData(response.data.daysSinceLastReqSent);
               })     
            OneCpPerformanceStatus.getAll().then((response) => {
              setCreateInvoiceData(response.data.daysSinceLastInvoiceCreate)
              setDeferInvoiceData(response.data.daysSinceLastInvoiceDefer)
              setPaidInvoiceData(response.data.daysSinceLastInvoicePaid)
              setProjectCodeData(response.data.daysSinceLastProjectReceived)          
            }) 
          } 
        }   
    }, [])

      // const handleSearch = (event) => {
      //   setSearchTerm(event.target.value)           
      //  }

      //  const clearSearch = () => {
      //   setSearchTerm('');
      //  }

      //  const submitSearch = (event) => {
      //   event.preventDefault();
      //   history.push({pathname: '/shipping-instructions', state: searchTerm, event: event})           
      // }

      const clickHandler = () => {
        history.push('/performance/dashboard')
      }

    return (
        <Container>
                 <h2>Welcome!</h2>
                                    {/* {access &&
                                   
                     <form  onSubmit={submitSearch}>                      
                     <Grid container spacing={4} style={containerStyle}>
                     <Grid item xs={3}>
                         <TextField
                             name="searchTerm"
                             fullWidth           
                             value={searchTerm}  
                             onChange={handleSearch}                            
                             label="Filter shipping instruction by PO number"
                              color="primary"                                  
                                 InputProps={{
                                     endAdornment: (
                                 <IconButton
                                   sx={{ visibility: searchTerm ? "visible" : "hidden" }}
                                   onClick={() => {clearSearch()}}
                                 >
                                   <ClearIcon />
                                 </IconButton>
                                     ),
                                   }}
                         />                         
                         
                         </Grid>
                        <Grid item xs={4}>
                     <Button variant="contained" color="primary" type="submit">
                             Go
                         </Button>
                     </Grid>
                     </Grid>
                     </form>
                           } */}
                 {dashboardAccess && 
                 <div>
     <Grid container spacing={4}>
         <Grid item xs={6}>
               <h2>Wambo to OneNet integration performance monitoring metrics</h2>
             <Grid container spacing={4}>               
              <Grid item xs={6}>
                 <Card sx={{ minWidth: 100 }}>
                   <CardContent>
                     <Typography sx={{ fontSize: 16 }}  gutterBottom>
                       Number Of Days Since Last Epo Received
                     </Typography>      
                 
                     <Typography sx={{ fontSize: 20 }}>
                      {epoData}
                     </Typography>
                   </CardContent>
                  
                 </Card>
                 </Grid> 
              <Grid item xs={6}>
                 <Card sx={{ minWidth: 100 }}>
                   <CardContent>
                     <Typography sx={{ fontSize: 16 }}  gutterBottom>
                       Number Of Days Since Last Requisition Received
                     </Typography>      
                 
                     <Typography sx={{ fontSize: 20 }}>
                      {reqData}
                     </Typography>
                   </CardContent>
                  
                 </Card>
             </Grid> 
           </Grid>
             <Grid container spacing={4} style={{marginTop: "1rem"}}>
                 <Grid item xs={6}>
                     <Card sx={{ minWidth: 100 }}>
                         <CardContent>
                             <Typography sx={{ fontSize: 16 }}  gutterBottom>
                                 Number Of Days Since Last Epo Sent
                             </Typography>

                             <Typography sx={{ fontSize: 20 }}>
                                 {epoSentData}
                             </Typography>
                         </CardContent>
                     </Card>
                 </Grid>
                 <Grid item xs={6}>
                     <Card sx={{ minWidth: 100 }}>
                         <CardContent>
                             <Typography sx={{ fontSize: 16 }}  gutterBottom>
                                 Number Of Days Since Last Requisition Sent
                             </Typography>
                             <Typography sx={{ fontSize: 20 }}>
                                 {reqSentData}
                             </Typography>
                         </CardContent>

                     </Card>
                 </Grid>

             </Grid>
             <Grid container spacing={4} style={{marginTop: "1rem"}}>
              <Grid item xs={6}>
                 <Card sx={{ minWidth: 100 }}>
                   <CardContent>
                     <Typography sx={{ fontSize: 16 }}  gutterBottom>
                     Number of days since last ASN file generated
                     </Typography>      
                 
                     <Typography sx={{ fontSize: 20 }}>
                      {asnData.toLocaleString()}
                     </Typography>
                   </CardContent>
                  
                 </Card>
                 </Grid> 
             
           </Grid>
       </Grid>
               
       <Grid item xs={6}>          
                <h2>OneNet to Costpoint integration performance monitoring metrics</h2>
           <Grid container spacing={4}>               
              <Grid item xs={6}>
                 <Card sx={{ minWidth: 100 }}>
                   <CardContent>
                     <Typography sx={{ fontSize: 16 }}  gutterBottom>
                       Number Of Days Since Last Create Invoice Received
                     </Typography>      
                 
                     <Typography sx={{ fontSize: 20 }}>
                      {createInvoiceData}
                     </Typography>
                   </CardContent>
                  
                 </Card>
                 </Grid> 
              <Grid item xs={6}>
                 <Card sx={{ minWidth: 100 }}>
                   <CardContent>
                     <Typography sx={{ fontSize: 16 }}  gutterBottom>
                       Number Of Days Since Last Defer Invoice Received
                     </Typography>      
                 
                     <Typography sx={{ fontSize: 20 }}>
                      {deferInvoiceData}
                     </Typography>
                   </CardContent>
                  
                 </Card>
             </Grid> 
           </Grid>
           <Grid container spacing={4} style={{marginTop: "1rem"}}>               
              <Grid item xs={6}>
                 <Card sx={{ minWidth: 100 }}>
                   <CardContent>
                     <Typography sx={{ fontSize: 16 }}  gutterBottom>
                       Number Of Days Since Last Paid Invoice Received
                     </Typography>      
                 
                     <Typography sx={{ fontSize: 20 }}>
                      {paidInvoiceData}
                     </Typography>
                   </CardContent>
                  
                 </Card>
                 </Grid> 
              <Grid item xs={6}>
                 <Card sx={{ minWidth: 100 }}>
                   <CardContent>
                     <Typography sx={{ fontSize: 16 }}  gutterBottom>
                       Number Of Days Since Last Project Received
                     </Typography>      
                 
                     <Typography sx={{ fontSize: 20 }}>
                      {projectCodeData}
                     </Typography>
                   </CardContent>
                  
                 </Card>
             </Grid> 
           </Grid>        
        </Grid>
      </Grid>
      <Grid container
           spacing={0}  
           alignItems="center"
           justifyContent="center"
           margin={2}
           sx={{ minHeight: '10vh' }}>
        <Button variant="contained" color="primary" onClick={clickHandler}>View More</Button>
      </Grid>
    </div>
            }
     
             </Container>
         );
     };

const chartFormat = {
  position: "relative",
  background: "White",
  margin: "2rem 0rem 0rem 0rem",
  padding: "1rem"
};

const containerStyle = {
  margin: "0 0 3rem 0"
}

export default Home;
